import React from "react";

const Price = ({ row }) => {
  return (
    <div>
      {row?.value?.map((c) => (
        <div style={{ marginBottom: "10px" }}>{c}</div>
      ))}
    </div>
  );
};

export default Price;
